// extracted by mini-css-extract-plugin
export default {"link":"SectionSeperator_link__q20aH","container":"SectionSeperator_container__gbL2R","icon":"SectionSeperator_icon__eWdnp","label":"SectionSeperator_label__92Opj"};